var _rect, _g, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _ellipse, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequirementGathering(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 345,
    viewBox: "0 0 314 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 180.024,
    height: 248.693,
    fill: "#EAE9E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_214_381)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.9089,
    y: 21.4155,
    width: 187.448,
    height: 259.829,
    fill: "#3600CE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6537 62.9394C54.8309 62.9394 50.1105 58.2191 50.1105 52.3962C50.1105 46.5733 54.8308 41.8529 60.6537 41.8529L182.837 41.8529C188.66 41.8529 193.38 46.5733 193.38 52.3961C193.38 58.2189 188.66 62.9393 182.837 62.9393L60.6537 62.9394Z",
    fill: "url(#paint0_linear_214_381)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5942,
    cy: 52.4083,
    r: 9.13749,
    transform: "rotate(-87.3867 60.5942 52.4083)",
    fill: "#3700D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6537 131.258C54.8309 131.258 50.1105 126.538 50.1105 120.715C50.1105 114.892 54.8308 110.172 60.6537 110.172L182.837 110.172C188.66 110.172 193.38 114.892 193.38 120.715C193.38 126.538 188.66 131.258 182.837 131.258L60.6537 131.258Z",
    fill: "url(#paint1_linear_214_381)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5942,
    cy: 120.726,
    r: 9.13749,
    transform: "rotate(-87.3867 60.5942 120.726)",
    fill: "#3700D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.658 76.6001C189.481 76.6001 194.202 81.3205 194.202 87.1434C194.202 92.9662 189.481 97.6866 183.658 97.6866L61.4753 97.6866C55.6524 97.6866 50.9321 92.9663 50.9321 87.1434C50.9321 81.3206 55.6524 76.6003 61.4753 76.6003L183.658 76.6001Z",
    fill: "url(#paint2_linear_214_381)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.715,
    cy: 87.1308,
    r: 9.13749,
    transform: "rotate(92.6133 183.715 87.1308)",
    fill: "#3700D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.658 143.894C189.481 143.894 194.202 148.614 194.202 154.437C194.202 160.26 189.481 164.981 183.658 164.981L61.4753 164.981C55.6524 164.981 50.9321 160.26 50.9321 154.437C50.9321 148.615 55.6524 143.894 61.4753 143.894L183.658 143.894Z",
    fill: "url(#paint3_linear_214_381)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.715,
    cy: 154.426,
    r: 9.13749,
    transform: "rotate(92.6133 183.715 154.426)",
    fill: "#3700D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.921 271.741L258.218 257.628L306.766 330.887L285.47 345L236.921 271.741Z",
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.818,
    cy: 209.14,
    r: 72.0458,
    transform: "rotate(-30.9087 214.818 209.14)",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.813,
    cy: 208.863,
    rx: 57.9975,
    ry: 57.5336,
    fill: "#3600CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.359 267.324C199.1 267.324 184.466 261.214 173.676 250.337C162.887 239.46 156.825 224.709 156.825 209.327C156.825 193.945 162.887 179.193 173.676 168.316C184.466 157.44 199.1 151.329 214.359 151.329L214.359 209.327L214.359 267.324Z",
    fill: "#EAE9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_214_381",
    x: 1.05004,
    y: 0.615978,
    width: 239.166,
    height: 311.547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.05935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.9295
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_381"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_381",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_381",
    x1: 197.878,
    y1: 49.0061,
    x2: 89.6546,
    y2: 48.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3CEF7",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_381",
    x1: 197.878,
    y1: 117.325,
    x2: 89.6546,
    y2: 116.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3CEF7",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_381",
    x1: 46.4345,
    y1: 90.5335,
    x2: 154.658,
    y2: 91.1297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3CEF7",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_214_381",
    x1: 46.4345,
    y1: 157.827,
    x2: 154.658,
    y2: 158.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3CEF7",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementGathering);
export default __webpack_public_path__ + "static/media/RequirementGathering.4b1c894c34e83a7b2a1fbeab284e2bc1.svg";
export { ForwardRef as ReactComponent };